export const DISPLAY_OVERLAY = 'DISPLAY_OVERLAY';
export const HIDE_OVERLAY = 'HIDE_OVERLAY';
export const SCREEN_WIDTH = "SCREEN_WIDTH";
export const HEADER_NAVIGATION = "HEADER_NAVIGATION";
export const SET_MOBILE_MENU_STATE = "SET_MOBILE_MENU_STATE";
export const WINDOW_SCROLL = "WINDOW_SCROLL";
export const MOBILE_OVERLAY_SHOW_HIDE = "MOBILE_OVERLAY_SHOW_HIDE";
export const RESET_GLOBAL_DATALAYER = 'RESET_GLOBAL_DATALAYER';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const SET_MYACCOUNTINFO = 'SET_MYACCOUNTINFO';
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';
export const SET_AUTHANTICATING = 'SET_AUTHANTICATING';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_PAGE_CONTENT_DATA = "SET_PAGE_CONTENT_DATA";
export const SET_URL_RESOLVER_TOKEN = "SET_URL_RESOLVER_TOKEN";
export const SET_FOOTER_DATA = "SET_FOOTER_DATA";
export const SET_GLOBAL_DATA_LAYER = "SET_GLOBAL_DATA_LAYER";
export const SET_WEEKS_DEPOSIT_BALANCE = "SET_WEEKS_DEPOSIT_BALANCE";
export const SET_CUSTOMER_PROFILE = "SET_CUSTOMER_PROFILE";
export const GA_COOKIE = '_ga';
export const MSG_SIGNOUT_DATA = "MSG_SIGNOUT_DATA";
export const MAIN_MENU_LINK_TEXT = "MAIN_MENU_LINK_TEXT";
export const TS_ASPOT_GENERIC_COMPONENT_CONTENT = "TS_ASPOT_GENERIC_COMPONENT_CONTENT";
export const FETCH_FEEDBACK_CONTENT_SUCCESS = 'FETCH_FEEDBACK_CONTENT_SUCCESS';
export const GET_RULES = 'GET_RULES';
export const GET_RULES_COMPONENT = 'GET_RULES_COMPONENT';
export const GET_RULES_FAILURE = 'GET_RULES_FAILURE';
export const GET_GALLERY_IMAGE_SUCCESS = 'GET_GALLERY_IMAGE_SUCCESS';
export const GET_GALLERY_VIDEO = 'GET_GALLERY_VIDEO';
export const GET_GALLERY_VIDEO_SUCCESS = 'GET_GALLERY_VIDEO_SUCCESS';
export const REMOVE_GALLERY_VIDEO = 'REMOVE_GALLERY_VIDEO';
export const GET_GALLERY_RCI_TV_VIDEO_SUCCESS = 'GET_GALLERY_RCI_TV_VIDEO_SUCCESS';
export const REMOVE_GALLERY_IMAGE = 'REMOVE_GALLERY_IMAGE';
export const FETCH_MESSAGE_CATALOG = 'FETCH_MESSAGE_CATALOG';
export const FETCH_MESSAGE_CATALOG_SUCCESS = 'FETCH_MESSAGE_CATALOG_SUCCESS';
export const FETCH_MESSAGE_CATALOG_ERROR = 'FETCH_MESSAGE_CATALOG_ERROR';
export const SYNC_MESSAGE_CATALOG_SUCCESS = 'SYNC_MESSAGE_CATALOG_SUCCESS';
export const FETCH_OGS_COUNT_SUCCESS = 'FETCH_OGS_COUNT_SUCCESS';
export const FETCH_TRIP_COUNT_SUCCESS = 'FETCH_TRIP_COUNT_SUCCESS';
export const SET_POINTS_BALANCE = 'SET_POINTS_BALANCE';
export const FETCH_ACCOUNT_INFO_ERROR = 'FETCH_ACCOUNT_INFO_ERROR';
export const RESET_POINT_BALANCE = 'RESET_POINT_BALANCE';
export const AUTH_COOKIE_STORE = '_barrierrciapp_';
